import { render, staticRenderFns } from "./PublicationShowCase.vue?vue&type=template&id=37e73078"
import script from "./PublicationShowCase.vue?vue&type=script&lang=js"
export * from "./PublicationShowCase.vue?vue&type=script&lang=js"
import style0 from "./PublicationShowCase.vue?vue&type=style&index=0&id=37e73078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports